import React, { FunctionComponent, useEffect, useState } from 'react';
import Container from '@material-ui/core/Container';
import styles from "./Common.module.scss";
import { data } from './local';
import { Box, Button, createStyles, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, FormGroup, makeStyles, styled, Switch, TextareaAutosize, useMediaQuery, useTheme } from '@material-ui/core';
import TextField from '@mui/material/TextField';
import { getNominatorMail, getToken, getUserGraphId } from './common';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { DateRange, StaticDateRangePicker } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { Theme } from '@mui/material/styles';
import { style } from '@mui/system';
import { addClosureData, getClosureData } from './services';
import { useLocation } from 'react-router-dom';
import { appInsights } from '../AppInsights';
import { pink } from '@mui/material/colors';
import { alpha } from '@mui/material/styles';


const NomSettings: FunctionComponent<any> = () => {

  const getcorrelationId = () => {
    return sessionStorage.getItem("correlationId");
}

  let history: any = useHistory()
  const [token, setToken] = useState<any>(null);
  useEffect(() => {
    getToken().then((token: any) => {
      setToken(token);
    });
  }, [])



  const [state, setState] = React.useState<boolean>(true);
  const languageSelected: any = useSelector((state: any) => state.lang);
  const languageData: any = data;
  const { NominationPeriodClosure } = languageData[languageSelected];

  let closureMessageText = NominationPeriodClosure.message;
  const [closureMessage, setClosureMessage] = React.useState<string>(closureMessageText);


  useEffect(() => {
    getClosureData().then((response: any) => {
      if (response != null) {
        setState(response.toggleState);
        if (!response.toggleState) {
          setClosureMessage(response.closureMessage);
        }
      }
    });
  }, [])


  const [labelText, setLabelText] = React.useState<string>('Disabled');
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [textAreaCount, setTextAreaCount] = React.useState(closureMessage.length);
  const [closeMessageShow, setCloseMessageShow] = React.useState<boolean>(false);


  useEffect(() => {
    if (state) {
      setLabelText('Enabled');
      setCloseMessageShow(false);
    }
    else {
      setLabelText('Disabled');
      setCloseMessageShow(true);
    }
  }, [state]);

  const handleChange = async (event: any) => {
    setState(event.target.checked);
    setOpen(true);
  }

  const handleTextAreaChange = async (event: any) => {
    setTextAreaCount(event.target.value.length);
    setClosureMessage(event.target.value);
  }

  const handleClose = () => {
    setOpen(false);
  };
  const disableApp = (event: any) => {
    handleClose();
    setState(false);
    insertClosureData();
  };
  const enableApp = () => {
    handleClose();
    setState(true);
    setTextAreaCount(closureMessageText.length);
    insertClosureData();
  };

  const handleExitNo = () => {
    handleClose();
    setState(!state);
  };

  const insertClosureData = () => {
    let options = {
      "createdBy": getNominatorMail(),
      "toggleState": state,
      "closureMessage": state ? null : closureMessage
    }
    let success = addClosureData(options);

    appInsights.trackEvent({ name: "NominationWindowChanged", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } })
  };





  return (
    <React.Fragment>
      <Container maxWidth={"xl"} >

        <div className={styles.adminPage} >

          <h2 className={styles.headerBold}>Please use the switch to enable/disable the nomination window</h2>
          <div>
            <FormGroup aria-label="position" row>
              <FormControlLabel
                checked={state}
                value="top"
                control={<Switch
                color = "primary"
                  onChange={handleChange} />}
                label={labelText}
                labelPlacement="end"
              />
            </FormGroup>
          </div><br />

          <br />
          <div>
            <Dialog
              fullScreen={fullScreen}
              open={open}
              onClose={handleClose}
              aria-labelledby="responsive-dialog-title"
            >
              <DialogTitle style={{ backgroundColor: '#00338e', fontFamily: 'barlow', color: '#FFFFFF' }} id="responsive-dialog-title" >{state ? "Are you sure you want to enable the nomination window?" : "Closure Message"}</DialogTitle>
              {!state ?
                <DialogContent>
                  <DialogContentText>
                    <div><br />
                      <TextareaAutosize id="dialogTextArea" className={styles.DialogTextArea} maxRows={6} aria-label="empty textarea" maxLength={300} defaultValue={NominationPeriodClosure.message} onChange={handleTextAreaChange} />
                      <div>
                        <span>{textAreaCount}/300</span>
                      </div>
                    </div>
                  </DialogContentText>
                </DialogContent> : <br />}
              <DialogActions>
                <Button onClick={state ? enableApp : disableApp} color="primary" className={styles.messageBox}>
                  {state ? "Yes" : "Submit"}
                </Button>
                <Button onClick={handleExitNo} color="primary" className={styles.messageBox}>
                  {state ? "No" : "Exit"}
                </Button>
              </DialogActions>
            </Dialog>

          </div>
          {closeMessageShow ?
            <div>
              <h2 className={styles.header}>Closure Message </h2>
              <hr />
              <div className={styles.messageBox}>
                {closureMessage}
              </div> </div> : null}
        </div>


      </Container>
    </React.Fragment>
  );
}

export default NomSettings;